import { StyleSheet } from "@react-pdf/renderer"

export const headerStyles=()=>{


    const header = StyleSheet.create({

        image: {
            flexGrow:2,
            maxWidth: 160,
        },
        dataHeaderContainer: {
            flexGrow:3,
            borderWidth:1,
            flexDirection: 'row',
        },
        dataIssuingCompanyContainer: {
            flexGrow:1,
            flexDirection: 'column',
            paddingHorizontal: 10,
            paddingVertical: 10,
            gap: 1
        },
        dataInvoiceGeneralSubcontainer: {
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
        textHeaderStyles: {
            fontSize: 7,
            paddingVertical: 3,
            fontWeight:500,
            color:"primary.main"
        },
        textHeaderStylesBold: {
            fontSize: 7,
            paddingVertical: 3,
            fontWeight: 700
        }
    })

    return {
        header
    }
}